import React, { useState } from 'react';
import './SlotMovePropagationDialog.css';

interface SlotMovePropagationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (propagate: boolean, weeks?: number) => void;
  slotName: string;
  loading?: boolean;
}

const SlotMovePropagationDialog: React.FC<SlotMovePropagationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  slotName,
  loading = false,
}) => {
  const [propagate, setPropagate] = useState(false);
  const [weeks, setWeeks] = useState<number | undefined>(undefined);

  // Log when loading state changes
  React.useEffect(() => {
    console.log('Dialog loading state changed:', loading);
  }, [loading]);

  if (!open) return null;

  const handleConfirm = () => {
    console.log('Dialog: Confirm clicked', { propagate, weeks, loading });
    try {
      console.log('Calling onConfirm callback...', onConfirm);
      onConfirm(propagate, weeks);
      console.log('onConfirm callback completed');
    } catch (error) {
      console.error('Error in onConfirm callback:', error);
    }
  };

  return (
    <>
      <div className="dialog-backdrop" onClick={loading ? undefined : onClose} />
      <div className="propagate-dialog">
        <div className="dialog-header">
          <h3>Move Activity Slot</h3>
          <button className="dialog-close-btn" onClick={onClose} disabled={loading}>
            ×
          </button>
        </div>

        <div className="dialog-content">
          <p className="slot-name-display">
            Moving: <strong>{slotName}</strong>
          </p>

          <div className="propagate-option">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={propagate}
                onChange={(e) => setPropagate(e.target.checked)}
              />
              <span>Propagate changes to recurring slots in downstream weeks</span>
            </label>
          </div>

          {propagate && (
            <div className="weeks-input-section">
              <label>
                Number of weeks to propagate (leave blank for all future weeks):
                <input
                  type="number"
                  min="1"
                  value={weeks || ''}
                  onChange={(e) => setWeeks(e.target.value ? parseInt(e.target.value) : undefined)}
                  placeholder="All future weeks"
                  className="weeks-input"
                />
              </label>
              <p className="help-text">
                This will update all slots with the same day-of-week and time in future weeks.
              </p>
            </div>
          )}
        </div>

        <div className="dialog-actions">
          <button className="dialog-btn cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="dialog-btn confirm-btn"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                {propagate ? 'Moving & Propagating...' : 'Moving...'}
              </>
            ) : (
              propagate ? 'Move & Propagate' : 'Move Only This Slot'
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default SlotMovePropagationDialog;
